module.exports = __webpack_public_path__ + "img/dashboard-users-male.e844079b.png";